import React from 'react'
import { Spin } from 'antd'
import styled from 'styled-components'

interface Props {
  tip?: string
  size?: 'small' | 'default' | 'large' | undefined
}

const CentredLoader = (props: Props): JSX.Element => {
  return (
    <Wrapper>
      <Spin tip={props.tip} size={props.size} />
    </Wrapper>
  )
}

export default CentredLoader

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`
